import { useEffect, useRef } from "react"

import { useFunctions } from "@app/hooks/useFunctions"
import { useCustomerContext } from "@app/providers/customer"

export const useCustomerBirthDate = (enabled = true) => {
  const { customer, token, setCustomer } = useCustomerContext()
  const { callFunction } = useFunctions()
  const requestId = useRef(0)
  const accessToken = token?.accessToken

  useEffect(() => {
    if (!enabled || !customer?.id || customer.birthDate !== undefined || !accessToken) return

    const currentRequest = ++requestId.current
    const customerId = customer.id

    callFunction("customer-birth-date", { customerAccessToken: accessToken })
      .then(result => {
        if (currentRequest !== requestId.current || result?.status !== "success") return
        setCustomer((prev: any) => {
          if (prev?.id !== customerId || prev.birthDate !== undefined) return prev
          return { ...prev, birthDate: result.birthDate ?? null }
        })
      })
      .catch((error: Error) => {
        console.error(error.message)
      })
  }, [enabled, customer?.id, customer?.birthDate, accessToken, callFunction, setCustomer])
}
